export default __webpack_public_path__ + "static/media/olive-rice.659bddfd.png";